export const FeatureFlags = {
  SiteMaps: 'hal-10-10419-ui',
  RemoveGatesFromTaskTypes: 'release-remove-gates-from-task-types',
  DriverDockGroups: 'release-driver-dock-group',
  LocationsHierarchy: 'hal-7-9218-ui',
  AllowImageCapture: 'release-image-capture-ui',
  MessagesSideMenu: 'task-9741-s-8-ui',
  UseYardOpsApi: 'firefly-1-9758-ui',
  OccupiedDoors: 'vulcan-7723-s-9-ui',
  SaveTableSortingState: 'release-save-sorting-state',
  ImageCancelButton: 'image-capture-cancel-btn',
  DirectTask: 'release-direct-task',
  EditTrailerNullEmptyTemperatures: 'release-edit-trailer-null-empty-temperatures',
  PageSelector: 'release-page-selector',
  DoneTaskSorting: 'release-sorting-tasks-done',
  ImageCaptureTasking: 'release-image-capture-tasking',
  GlobalUserSearch: 'release-global-user-search',
  SignalRRefactor: 'release-signalr-refactor',
  NewLoginFlow: 'release-sso-auth-login',
  RetainDriverPhoneNumber: 'release-retain-driver-number',
  ReleaseAzureStorage: 'release-azure-sas-token',
  DockActivityUseDockGroupIdsEndpoint: 'release-tasks-doors-with-dockgroupids',
  CarrierManagementImprovement: 'release-carrier-management-improvement',
  NaturalSort: 'release-use-natural-sort',
  TrailerInventoryAttributesColumn: 'release-trailer-inventory-attributes-column',
  PendingTasksDisableSort: 'release-disable-pending-tasks-sort',
  DisableImportTrailerBtn: 'temp-import-trailer-btn',
  ProductProtection: 'release-product-protection',
  DirectTaskOnlyArrived: 'release-direct-task-only-arrived',
};
